import { AnalyticsEvent, CommonPayload, Tracker, convertForRudderstack } from '@water-web/view';
import { CustomerModel } from '@water-web/repository';

export class RudderStackTracker implements Tracker {
  getName(): string {
    return 'RudderStackTracker';
  }

  track(analyticsEvent: AnalyticsEvent, payload: CommonPayload): void {
    const converted = convertForRudderstack(analyticsEvent, payload);

    if (!converted) {
      return;
    }

    window.rudderanalytics?.track(converted.event, converted.payload);
  }

  trackCustomerInfo(customer: CustomerModel): void {
    // Only identify customer if they are logged in
    if (customer.getUserId()) {
      window.rudderanalytics?.identify(customer.getUserId(), customer.toJson());
    }
  }

  page(location: string, payload: CommonPayload): void {
    window.rudderanalytics?.page(location, payload);
  }

  identify(userId: string): void {
    if (userId) {
      window.rudderanalytics?.identify(userId);
    }
  }
}
